import React from 'react';
import { map, find, get, join, filter, includes } from 'lodash';
import { Table, Switch, Tooltip } from 'antd';
import { func, array, bool } from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import { Text, Row, Icon, FlexContainer } from '../../common';
import { monthOptions } from '../../../utils/misc';

const CustomChip = styled.div`
    width: 40px;
    height: 30px;
    border-radius: 16px;
    background-color: #89A503;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const actionIcons = (handleEdit, handleRequired, handleModalConfirmation) => {
    return [
        { name: 'pencil-edit', action: (item) => handleEdit(item), toolTip: 'Editar', toolTipDisabled: 'Encuesta no puede ser editada' },
        { name: 'required', action: (item) => handleRequired(item), toolTip: 'Obligatoriedad', toolTipDisabled: 'Encuesta no puede ser editada' },
        { name: 'duplicate', action: (item) => handleModalConfirmation(item, 'duplicate'), toolTip: 'Duplicar' },
        { name: 'new-trash', action: (item) => handleModalConfirmation(item, 'delete'), toolTip: 'Eliminar' },
        { name: 'export', action: (item) => handleModalConfirmation(item, 'export'), toolTip: 'Exportar' }
    ];
};

const getColumns = (handleEdit, handleRequired, handleModalConfirmation) => {
    return [
        {
            title: 'Nombre encuesta',
            dataIndex: 'namePoll',
            key: 'namePoll'
        },
        {
            title: 'Meses a evaluar',
            dataIndex: 'monthsEvaluate',
            align: 'center',
            key: 'monthsEvaluate',
            render: (value) => {
                const months = filter(monthOptions, ({ value: idMonth }) => includes(map(value, 'months_evaluate'), idMonth));
                return <Text text={join(map(months, 'label'), ' - ')} />;
            }
        },
        {
            title: 'Creado',
            dataIndex: 'userCreate',
            key: 'userCreate',
            align: 'center',
            render: (value) =>
                <Text text={value || '-'} />
        },
        {
            title: 'Actualizado',
            dataIndex: 'userUpdate',
            key: 'userUpdate',
            align: 'center',
            render: (value) =>
                <Text text={value || '-'} />
        },
        {
            title: 'Fecha de creación',
            dataIndex: 'dateCreate',
            key: 'dateCreate',
            align: 'center',
            render: (value) =>
                <Text text={moment(value).format('YYYY-MM-DD HH:mm')} />
        },
        {
            title: 'Fecha de actualización',
            dataIndex: 'dateUpdate',
            key: 'dateUpdate',
            align: 'center',
            render: (value) =>
                <Text text={moment(value).isValid() ? moment(value).format('YYYY-MM-DD HH:mm') : '-'} />
        },
        {
            title: 'Respuestas',
            dataIndex: 'numberReponses',
            align: 'center',
            key: 'numberReponses',
            render: (value) => <Row justify='center' align='center'>
                <CustomChip><Text text={value || '0'} strong color='white' /></CustomChip>
            </Row>
        },
        {
            title: 'Activo/Inactivo',
            dataIndex: 'status',
            align: 'center',
            key: 'status',
            render: (value, item) =>
                <Switch checked={value === 1} onChange={() => handleModalConfirmation(item, 'status')} />
        },
        {
            title: 'Acciones',
            key: 'action',
            render: (_, item) => {
                return <Row gap={25} noWrap>
                    {map(actionIcons(handleEdit, handleRequired, handleModalConfirmation), ({ name, action, toolTip, toolTipDisabled }, index) => {
                        const disabledExport = get(item, 'numberReponses', 0) === 0 && includes(['Exportar'], toolTip)
                        return (<Tooltip disabled placement='top' title={disabledExport ? toolTipDisabled : toolTip} key={index} autoAdjustOverflow={false}>
                            <a><Icon name={name} color={`${disabledExport ? '#ccc' : '#1fa02e'}`} size={23} pointer onClick={() => disabledExport ? {} : action(item)} /></a>
                        </Tooltip>);
                    })}
                </Row>;
            }
        }
    ];
};

const TablePolls = ({ handleEdit, handleRequired, handleModalConfirmation, data, loading }) => {
    return <FlexContainer shrink={0} grow={1} style={{ padding: '0px 25px' }} direction='column'>
        <Table
            rowKey={record => record.idPoll}
            pagination={false}
            style={{ backgroundColor: 'white', border: '1px solid rgb(234, 234, 234)' }}
            columns={getColumns(handleEdit, handleRequired, handleModalConfirmation)}
            dataSource={data}
            loading={loading}
            scroll={{ x: 1500 }}
        />
    </FlexContainer>;
};

TablePolls.propTypes = {
    handleEdit: func,
    handleRequired: func,
    handleModalConfirmation: func,
    data: array,
    loading: bool
};

export default withApollo(TablePolls);
